// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3GFvQ","gfeWrapper":"CalendarEvent_gfeWrapper__2-ILz"};